const IconPlusHomepageBackground = () => (
  <svg
    width="282"
    height="44"
    viewBox="0 0 282 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9023_103708)">
      <path
        d="M51.4786 10.5179L41.0472 34.9832L38.0705 13.7335C37.6919 10.8395 42.4833 9.07088 42.4833 9.07088C42.0394 8.07941 40.538 8.0928 40.538 8.0928H37.3002C36.7911 2.86747 41.4127 -0.937646 46.3999 0.214607C51.3088 1.34006 53.0844 6.81997 51.4916 10.5313L51.4786 10.5179Z"
        fill="white"
      />
      <path
        d="M32.1039 42.8881L11.7634 28.9807C6.5803 25.4302 1.46252 29.0477 0.378912 32.7858C-1.22692 38.2925 2.36336 42.8881 7.9903 42.8881H32.1039Z"
        fill="white"
      />
      <path
        d="M34.7671 8.41387C35.5243 3.01436 30.8113 -0.978331 25.7066 0.200719C20.7977 1.32618 19.0221 6.80608 20.6149 10.5174L31.0463 34.9827L34.7671 8.41387Z"
        fill="white"
      />
      <path
        d="M30.2115 38.989L20.1979 15.5688C17.8479 10.1425 11.6465 9.45918 8.21288 12.648C5.79761 14.8989 3.91761 21.0085 9.32261 24.7064L30.2115 38.989Z"
        fill="white"
      />
      <path
        d="M64.1019 42.8881C69.7288 42.8881 73.3061 38.2925 71.7133 32.7858C70.6297 29.0477 65.5119 25.4302 60.3288 28.9807L39.9883 42.8881H64.1019Z"
        fill="white"
      />
      <path
        d="M62.7717 24.7064C68.1767 21.0085 66.2967 14.8989 63.8814 12.648C60.4478 9.45918 54.2464 10.1425 51.8964 15.5688L41.8828 38.989L62.7717 24.7064Z"
        fill="white"
      />
      <path
        d="M122.775 1.09863H132.319L151.994 28.123V1.09863H160.937V42.8879H151.393L131.718 15.81V42.8879H122.775V1.09863Z"
        fill="white"
      />
      <path
        d="M206.513 29.7308C206.513 41.1059 197.635 42.8879 192.099 42.8879H168.43V1.09863H192.073C199.332 1.09863 205.116 5.3191 205.116 13.2375C205.116 17.1632 202.426 19.3203 200.377 20.3922C203.745 22.1206 206.5 24.6796 206.5 29.7308H206.513ZM177.059 8.93664V16.8416H191.016C193.314 16.8416 195.846 15.8502 195.846 12.9159C195.846 9.9817 193.875 8.93664 190.689 8.93664H177.059ZM197.309 29.7308C197.309 25.7247 194.058 24.6796 190.885 24.6796H177.072V34.6614H191.212C193.797 34.6614 197.309 33.7369 197.309 29.7308Z"
        fill="white"
      />
      <path
        d="M251.646 36.0816C247.181 40.0073 242.364 44 232.846 44C220.195 43.9464 210.391 33.8843 210.391 21.9196C210.456 9.57978 220.665 0 232.964 0C243.643 0 249.388 7.02071 250.132 7.79781L243.408 14.6979C241.946 13.1705 238.786 9.70037 232.898 9.70037C225.744 9.70037 219.921 15.1937 219.921 21.9598C219.921 27.8551 224.869 34.2192 232.846 34.2192C239.217 34.2192 241.567 32.0755 245.484 28.6991L251.646 36.0682V36.0816Z"
        fill="white"
      />
      <path
        d="M118.675 36.0816C114.21 40.0073 109.393 44 99.8755 44C87.2246 43.9464 77.4199 33.8843 77.4199 21.9196C77.4852 9.57978 87.6946 0 99.993 0C110.672 0 116.417 7.02071 117.161 7.79781L110.437 14.6979C108.975 13.1705 105.816 9.70037 99.9277 9.70037C92.7733 9.70037 86.9505 15.1937 86.9505 21.9598C86.9505 27.8551 91.8985 34.2192 99.8755 34.2192C106.247 34.2192 108.597 32.0755 112.513 28.6991L118.675 36.0682V36.0816Z"
        fill="white"
      />
      <path
        d="M282 17.3374H272.704V7.79785H263.748V17.3374H254.439V26.5287H263.748V36.0817H272.704V26.5287H282V17.3374Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9023_103708">
        <rect width="282" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconPlusHomepageBackground;
